import { Component, type ErrorInfo, type ReactNode } from 'react';
import i18n from '../i18n';

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    if (import.meta.env.DEV) console.error(error, info);
  }

  override render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="error-page">
        <img src="./app-icon.svg" alt="" width="96" height="96" />
        <h1>{i18n.t('errors.title')}</h1>
        <p>{i18n.t('errors.generic')}</p>
        <button
          className="button button-primary button-md"
          onClick={() => window.location.reload()}
        >
          {i18n.t('errors.recovery')}
        </button>
      </main>
    );
  }
}
